export { SessionLinkType, SessionLinkMethodType } from './windcave';
export {
  AddressFlow,
  FlatType,
  FloorType,
  State,
  StreetSuffix,
  StreetType,
} from './address';
export { SignupBillingCallbackType, SignupSteps } from './sign-up-flow';
export * from './bank';
export * from './gas-service-postcodes';
export * from './plans';
export { SECRET_PREFIX } from './aws';

export enum CustomerType {
  Business = 'Business',
  Residential = 'Residential',
}

export enum PaymentMethodType {
  CreditDebitCard = 'Credit/Debit Card',
  DirectDebit = 'Bank Account',
}

export enum ProductType {
  Default = 'default',
  Gas = 'gas',
  GasPowerHouse = 'gas-power-house',
  EvDay = 'ev-day',
  EvNight = 'ev-night',
  EvDaySaver = 'ev-day-saver',
  EvNightSaver = 'ev-night-saver',
  Solar = 'solar',
  Sustainable = 'sustainable',
  Power = 'power',
}

export enum PriceFrequency {
  Yearly = 'yearly',
  Quarterly = 'quarterly',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export enum TooltipText {
  VDO = 'The Victorian Default Offer is set of rates set by the Essential Services Commission (ESC) which we are required to compare our offers against. We recommend you contact us for a more accurate comparison if you are on an alternative tariff.',
  DMO = 'The Default Market Offer (also referred to as the reference price) is a maximum annual price retailers can charge a Standing Offer customer based on a customer’s usage, tariff and distribution area. All energy retailers in NSW, QLD and SA are required to compare their offers against the Default Market Offer.',
}

export enum EnergyType {
  Gas = 'Gas',
  Electricity = 'Electricity',
}

export enum FluxAccountType {
  Residential = 'residential',
  Business = 'business',
}

export enum FluxPartyType {
  Person = 'person',
  Organization = 'organization',
}

export enum FluxAccountHolder {
  DR = 'DR',
  MISS = 'MISS',
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
}

export enum FluxCurrentSituation {
  Existing = 'existing',
  Moving = 'moving',
}

export enum FluxHazards {
  Dog = 'Dog',
  ElectricFence = 'Electric fence',
  ElectricalSafetyIssue = 'Electrical safety issue',
  AsbestosFuse = 'Asbestos fuse',
  AsbestosBoard = 'Asbestos board',
  CustomerCaution = 'Customer Caution',
  Other = 'Other',
}

export enum FluxUtilityType {
  Electricity = 'electricity',
  Gas = 'gas',
}

export enum FluxPeriod {
  Monthly = 'monthly',
  BiMonthly = 'bi-monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

export enum KmPerYear {
  Less10000 = 'Up to 10000',
  Between10000And15000 = '10000-15000',
  Between15000And20000 = '15000-20000',
  More20000 = 'More than 20000',
}

export const evNightSlugs = ['ev-night', 'ev-night-saver'];
export const evSlugs = ['ev-day', 'ev-night', 'ev-day-saver', 'ev-night-saver'];

export const mappedDistributorsFromBusinessForVicEVPlans = [
  'CitiPower',
  'Powercor',
  'Jemena',
  'Ausnet Services',
  'United Energy',
];

export const evDayLoadProfile = {
  superOffPeak: '18%',
  offPeak: '56%',
  peak: '26%',
};

export const evNightLoadProfile = {
  superOffPeak: '41%',
  offPeak: '37%',
  peak: '22%',
};
